import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.9 30.8" {...props}><circle cx="3.4" cy="3.3" r="3.2" /><circle cx="3.4" cy="15.4" r="3.2" /><circle cx="3.4" cy="27.5" r="3.2" /></svg>;